import { useEffect, useRef, useState } from 'react';

/**
 * Smooth count-up animation for KPI values.
 * Uses requestAnimationFrame with ease-out cubic.
 */
function AnimatedNumber({ value, duration = 800, decimals = 0, suffix = '', prefix = '' }) {
  const [display, setDisplay] = useState(value || 0);
  const fromRef = useRef(value || 0);
  const startRef = useRef(null);

  useEffect(() => {
    fromRef.current = display;
    startRef.current = null;
    let raf;
    const step = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const elapsed = ts - startRef.current;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const next = fromRef.current + (value - fromRef.current) * eased;
      setDisplay(next);
      if (progress < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, duration]);

  return (
    <>
      {prefix}
      {Number.isFinite(display) ? display.toFixed(decimals) : '—'}
      {suffix}
    </>
  );
}

export default AnimatedNumber;
